import React from 'react';
import { useResourceContext } from '../../contexts/ResourceContext';
import { useAttachmentContext } from '../../contexts/AttachmentContext';

const StudyPanelTitle: React.FC = () => {
  const { expandedResource, isResourcesListVisible } = useResourceContext();
  const {
    textFiles,
    setTextFiles,
    activeTextAttachmentFileId,
    isTextAttachmentViewOpen,
  } = useAttachmentContext();
  const activeFile = isTextAttachmentViewOpen
    ? textFiles.find(file => file.id === activeTextAttachmentFileId)
    : undefined;
  const isEditableDraft = Boolean(
    activeFile?.id.startsWith('create-') && !activeFile.url
  );

  if (activeFile && isEditableDraft) {
    const updateName = (name: string) => {
      setTextFiles(previous => previous.map(file =>
        file.id === activeFile.id ? { ...file, name } : file
      ));
    };

    return (
      <input
        className="resource-panel-title-field"
        value={activeFile.name}
        onChange={event => updateName(event.target.value)}
        onBlur={() => {
          if (!activeFile.name.trim()) {
            updateName(activeFile.type === 'code' ? 'Untitled.js' : 'Untitled.md');
          }
        }}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === 'Escape') {
            event.currentTarget.blur();
          }
        }}
        aria-label="File name"
        title={activeFile.name}
        spellCheck={false}
        tabIndex={isResourcesListVisible ? -1 : 0}
        style={{
          opacity: isResourcesListVisible ? 0 : 1,
          pointerEvents: isResourcesListVisible ? 'none' : undefined,
        }}
      />
    );
  }

  const title = activeFile?.name || expandedResource?.title;
  if (!title) return null;

  return (
    <h2
      title={title}
      className="text-sm font-medium overflow-hidden text-ellipsis whitespace-nowrap min-w-0 flex-1 m-0"
      style={{
        opacity: isResourcesListVisible ? 0 : 1,
        transition: 'opacity 0.15s ease-out',
      }}
    >
      {title}
    </h2>
  );
};

export default StudyPanelTitle;
